module.exports = __webpack_public_path__ + "static/schwalbenschwanz-0fa4e4c9d0ffd61b21b8470f817bec35.jpg";